import React, { Component, useEffect, useState } from "react";
import Moment from "react-moment";
import PageHeader from "../Comman/PageHeader";
import UploadDocPopup from "../UploadDocPopup";
import { useLocation, useNavigate } from "react-router-dom";
import { getFieldData, getFormatedNumber } from "../../Services/appService";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser } from "../../app/store/auth";
import { getAlert, getConfirmAlert } from "../../Services/appAlerts";
import {
  getDocDeletedStatus,
  getPartCandidateAppTasks,
  getPartnerCandidateApps,
  getPartnerFilterCandidate, getUpdateDocSentStatus,
  loadCandidateAppRuningTasks,
  loadPartnerCandidateApps,
  loadPartnerFilterCandidate, partnerCandidateDocDelete, partnerCandidateDocSend
} from "../../app/store/partner";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import useDocDownload from "../../app/hooks/useDocDownload";
import { getReqDocuments, loadReqDocuments } from "../../app/store/documents";
import { getAppDocuments, loadAppDocuments } from "../../app/store/candidate";
import { OverlayTrigger, Popover } from "react-bootstrap";

export default function CandidateWorkingHub() {
  const route = [
    { name: "Contract Management", url: "" },
    { name: "List of Candidates", url: "/PartnerCandidates" },
  ];

  const reqDocuments1 = [
    {
      id: 1,
      date: "11/27/2021",
      name: "Copy of Candidate's e-verify approval",
      size: "1.3 Kb",
      type: "pdf",
      status: false,
      uploaded: 1,
      docusign: false,
      type: "",
      download: false,
    },
    {
      id: 2,
      date: "11/27/2021",
      name: "Copy of Candidate's approved I-9",
      size: "1.3 Kb",
      type: "pdf",
      status: false,
      uploaded: 1,
      docusign: false,
      type: "",
      download: false,
    },
    {
      id: 3,
      date: "11/27/2021",
      name: "Copy of VISA Status",
      size: "1.3 Kb",
      type: "pdf",
      status: false,
      uploaded: 1,
      docusign: false,
      type: "",
      download: false,
    },
    {
      id: 4,
      date: "11/27/2021",
      name: "Other",
      size: "1.3 Kb",
      type: "pdf",
      status: false,
      uploaded: 1,
      docusign: false,
      type: "",
      download: false,
    },
  ];

  const [candidateObj, setCandidateObj] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [wfTask, setWfTask] = useState(null);
  const [docShowHide, setDocShowHide] = useState(false);
  const [reqDocuments, setReqDocuments] = useState([]);
  const [docType, setDocType] = useState("");
  const [allAppDocs, setAllAppDocs] = useState([]);
  const [appWorkflow, setAppWorkflow] = useState(null);

  const partCandidateAppsSelector = useSelector(getPartnerCandidateApps);
  const partCandidateAppTasksSelector = useSelector(getPartCandidateAppTasks);
  const docSendStatus = useSelector(getUpdateDocSentStatus);
  const partnerFilterCandidateSelector = useSelector(getPartnerFilterCandidate);
  const reqDocumentsSelector = useSelector(getReqDocuments);
  const appDocumentsSelector = useSelector(getAppDocuments);
  const docDeletedStatusSelector = useSelector(getDocDeletedStatus);

  const [handleDownloadFile] = useDocDownload();

  const dispatch = useDispatch();
  const location = useLocation();
  const currentUser = getCurrentUser();
  const navigate = useNavigate();
  const usrType = localStorage.getItem("userType");

  useEffect(() => {
    dispatch(setCurrentPageTitle("Candidate Upload Documents"));
    dispatch(setCurrentRoute(route))
  }, [])

  useEffect(() => {
    const state = location.state;
    if (state) {
      setSelectedItem(state);
      if (state.subcontractor?.fuid && state?.performerid > 0) {
        dispatch(loadPartnerFilterCandidate(state.subcontractor?.fuid, state.performerid));
        dispatch(loadPartnerCandidateApps(state.performerid));
      }
    }
  }, []);

  useEffect(() => {
    if (partnerFilterCandidateSelector.length > 0) {
      setCandidateObj(partnerFilterCandidateSelector[0]);
    }
  }, [partnerFilterCandidateSelector])

  useEffect(() => {
    if (selectedItem && partCandidateAppsSelector.length > 0) {
      const mainWorkflow = partCandidateAppsSelector.filter(x => x.workflowType === 1);
      if (mainWorkflow.length > 0 && selectedItem?.performerid > 0) {
        const wf = mainWorkflow[0];
        if (selectedItem?.performerid > 0) {
          setAppWorkflow(wf);
          dispatch(loadCandidateAppRuningTasks(wf.oldWorkflowId, selectedItem.performerid));
        }
      }
    }
  }, [partCandidateAppsSelector]);

  useEffect(() => {
    if (partCandidateAppTasksSelector.length > 0) {
      const filterTasks = partCandidateAppTasksSelector.filter(x => x.taskType === 1 && x.wiid > 0);
      if (filterTasks.length > 0) {
        setWfTask(filterTasks);
        dispatch(loadReqDocuments(filterTasks[0].ciid));
      }
    }
    else {
      setWfTask(null);
    }
  }, [partCandidateAppTasksSelector]);

  useEffect(() => {
    if (reqDocumentsSelector.length > 0) {
      const reqDocs = reqDocumentsSelector.filter(x => x.sendStatus === true && x.performerId !== selectedItem?.performerid);
      setReqDocuments(reqDocs);
      if (appWorkflow && selectedItem?.performerid > 0)
        dispatch(loadAppDocuments(appWorkflow.oldWorkflowId, selectedItem.performerid));
    }
  }, [reqDocumentsSelector]);

  useEffect(() => {
    if (appDocumentsSelector.length > 0) {
      const appDocs = appDocumentsSelector;
      setAllAppDocs(appDocs);

      // let receiveDoc = appDocs.filter(
      //     (x) =>
      //         x.type === "received" &&
      //         x.uploadType !== "Invoice" &&
      //         x.uploadType !== "reporting" &&
      //         x.uploadType !== "client" &&
      //         x.uploadType !== "project" &&
      //         x.docType !== "internal" &&
      //         x.docType !== "Messaging" &&
      //         x.docModifiedName !== "esign" &&
      //         //!x.docType?.includes("_c2c") &&
      //         x.sendStatus === true &&
      //         x.deleteFlag !== true
      // );
      // let sentDocs = appDocs.filter(
      //     (x) =>
      //         x.type === "send" &&
      //         x.uploadType !== "Invoice" &&
      //         x.docType !== "internal" &&
      //         x.docType !== "Messaging" &&
      //         x.uploadType !== "Messaging" &&
      //         x.uploadType !== "monthly_time_sheet" &&
      //         x.uploadType?.substring(0, 3) !== "ach" &&
      //         x.uploadType?.substring(0, 3) !== "req" &&
      //         x.uploadType?.substring(0, 9) !== "insurance"

      // );
      // setReceivedDocs(receiveDoc);
      // setSentDocs(sentDocs);
    }

  }, [appDocumentsSelector]);

  useEffect(() => {
    if (docSendStatus === "success") {
      getAlert("", "Sent Successfully", "success");
      if (selectedItem.subcontractor?.fuid)
        dispatch(loadPartnerFilterCandidate(selectedItem.subcontractor?.fuid, selectedItem.performerid));
    }
  }, [docSendStatus])

  const handleUploadDocShowHide = (docs) => {
    if (docs === "save") {
      setDocShowHide(false);
      //setSelectedDoc(null);
      setDocType("");
      //dispatch(loadPartnerFilterCandidate(selectedItem.subcontractor?.fuid, selectedItem.performerid));
      if (wfTask[0]?.ciid > 0)
        dispatch(loadReqDocuments(wfTask[0].ciid));
    } else {
      setDocShowHide(!docShowHide);
      //setSelectedDoc(docs);
      setDocType(docs);
    }
  };

  const handleSendDoc = async (id) => {
    const docIds = [id];
    const frm = new FormData();
    frm.append("ids", docIds);
    frm.append("userId", currentUser.id);
    dispatch(partnerCandidateDocSend(frm));
  };

  const getUploadStatus = (doc) => {
    if (candidateObj) {
      let docs
      if (usrType === "subcontractor") {
        docs = candidateObj.docList.filter(
          (x) => x.type === `${doc.id}_c2c_${candidateObj?.loanamountlimit}`
        );
      } else if (usrType === "recruiter") {
        docs = candidateObj.docList.filter(
          (x) => x.type === `${doc.id}_c2c_${candidateObj?.activeloans}`
        );
      }

      if (docs.length === 0 && wfTask) {
        return <button
          className="btn btn-link btn-sm p-0"
          onClick={() => handleUploadDocShowHide(doc)
          }
        >
          Upload
        </button>
      }
    }
    return "";
  }

  const getUploadedDoc = (doc) => {
    if (candidateObj) {

      let findDoc
      if (usrType === "subcontractor") {
        findDoc = candidateObj.docList.filter((x) => x.type === `${doc.id}_c2c_${candidateObj?.loanamountlimit}`);
      } else if (usrType === "recruiter") {
        findDoc = candidateObj.docList.filter((x) => x.type === `${doc.id}_c2c_${candidateObj?.activeloans}`);
      }

      if (findDoc.length > 0) {
        const x = findDoc[0];
        return (
          <>
            <td>
              <button
                className="btn btn-sm btn-link p-0"
                title="Download Document"
                onClick={() => handleDownloadFile(x)}
              >
                {x.documentName}
              </button>
            </td>
            <td>
              {x.sendStatus ? (
                <span>
                  <i className="fa fa-check mr-1" aria-hidden="true"></i>
                  Sent
                </span>
              ) : (
                <button
                  className="btn btn-sm btn-link"
                  onClick={() => handleSendDoc(x.id)}
                >
                  Send
                </button>
              )}
              <br />
              {x.sendDateTime && (
                <Moment format="MMM Do YYYY">{x.sentDateTime}</Moment>
              )}
            </td>
          </>
        );
      }
    }

    return (
      <>
        <td></td>
        <td></td>
      </>
    );
  };

  const getReqRefDocs = (item) => {
    if (item.refDocId > 0) {
      const findDocs = allAppDocs.filter(x => x.uploadId === item.refDocId);
      if (findDocs.length > 0) {
        return <>
          {findDocs.map(doc =>
            <td>
              <button
                className="btn btn-link btn-sm p-0"
                title="Download Document"
                onClick={() => handleDownloadFile(doc)
                }
              >
                {doc.documentName}
              </button>
              <br />
              {item.documnetName}
            </td>
          )}
        </>
      }
    }

    return <td>{item.documnetName}</td>

  }

  const getReqUploadedDocs = (item, type) => {
    const achDocs = allAppDocs.filter(
      (x) => x.docType === `req_${item.id}`
    );

    if (achDocs.length === 0) {
      return <>
        <td>
          {item.docType?.includes('_c2c_') && "Contract"}
          {(item.docType !== "sharing" && !item.docType?.includes('_c2c_') && type !== "received") ? "Pending" : type === "received" && "Received"}
        </td>
        <td>
          {item.docType !== "sharing" && !item.docType?.includes('_c2c_') && type !== "received" &&
            <button
              className="btn btn-outline-default btn-sm btn-min-width"
              onClick={() => handleUploadDocShowHide(`req_${item.id}`)}
            >
              <i className="fa fa-upload" ></i> Upload
            </button>
          }
        </td>

      </>
    }

    if (achDocs.length > 0) {
      const doc = achDocs[achDocs.length - 1];
      return <>
        <td>Uploaded</td>
        <td>
          <button
            className="btn btn-link btn-sm p-0"
            title="Download Document"
            onClick={() => handleDownloadFile(doc)
            }
          >
            {doc.documentName}
          </button>
          {getPopover(doc.notes)}
          <button
            className="btn btn-sm btn-link text-danger"
            title="Delete File"
            onClick={() => handleDeleteFile(doc, "doc", item)}
          >
            <i className="fa fa-trash"></i>
          </button>
        </td>

      </>
    }
  }

  const handleDeleteFile = async (doc, type, item) => {
    if (item.status === 1) return getAlert("", "You cannot delete approved document", "error");
    const confirm = await getConfirmAlert("", "Are you sure you want to delete this document?", "warning");
    if (confirm.isConfirmed) {
      dispatch(partnerCandidateDocDelete(doc.id, type));
    }
  };

  useEffect(() => {
    if (docDeletedStatusSelector) {
      getAlert("", "Deleted Successfully", "success");
      if (wfTask[0]?.ciid > 0)
        dispatch(loadReqDocuments(wfTask[0].ciid));
    }
  }, [docDeletedStatusSelector])

  const getPopover = (notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <OverlayTrigger trigger="click" placement="top" overlay={popover}>
        <i className="fa fa-info-circle btn btn-sm" style={{ cursor: "pointer" }}></i>
      </OverlayTrigger>
    );
  };

  const getPopover1 = (notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <OverlayTrigger trigger="click" placement="top" overlay={popover}>
        <button className="btn btn-sm btn-link"> View</button>
      </OverlayTrigger>
    );
  };

  // const handleUploadShowHide = (type) => {
  //   if (type === "save") {
  //     setUploadDocShowHide(false);
  //     dispatch(loadAppDocuments(wfId, currentUser.id));
  //   }
  //   else {
  //     const reviewApp = appTasklist.filter((x) => x.registrationType === "WP");
  //     if (reviewApp.length > 0) {
  //       const lastReviewer = reviewApp[0];
  //       setWfTask([lastReviewer]);
  //     } else {
  //       getAlert("", "No reviewer found", "error");
  //     }
  //     setUploadDocShowHide(!uploadDocShowHide);
  //     setDocType(type);
  //   }
  // };

  const handleDocumentLoad = () => {
    if (wfTask[0]?.ciid > 0)
      dispatch(loadReqDocuments(wfTask[0].ciid));
  }

  let item = "";
  if (candidateObj)
    item = candidateObj;

  return (
    <React.Fragment>
      <div className="col-md-12 text-right">
        <button
          className="btn btn-sm btn-outline-default btn-min-width mb-2 mt-2"
          onClick={() => navigate(-1)}
        >
          <i className="fa fa-arrow-left" aria-hidden="true"></i> Back
        </button>
      </div>
      <div className="col-md-12 form-group">
        <div className="table-responsive">
          <table className="table align-items-center table-flush table-hover table-striped mb-2 border">
            <thead className="thead-light">
              <tr>
                <th>Candidate #<br />IPCS ID</th>
                <th>Candidate Details</th>
                <th>Agency / Client</th>
                <th>Duration</th>
                <th>Onboarding Status</th>
              </tr>
            </thead>
            <tbody>
              {item !== "" &&
                <tr>
                  <td>
                    {item.performerid}
                    <br />
                    {item.maxloans}
                  </td>
                  <td>
                    <span className="text-uppercase font-weight-bold">
                      {item.performername} {item.lastName}
                    </span>
                    <br />
                    <span>{item.performeremail}</span>
                    <br />
                    {item.contactNo && getFormatedNumber(item.contactNo)}
                    <br />
                    {getFieldData(
                      item.performerData,
                      "projectengagement",
                      "PositionTitle"
                    )}
                  </td>
                  <td>
                    {getFieldData(
                      item.performerData,
                      "projectengagement",
                      "AgencyName"
                    )}
                  </td>
                  <td>
                    {item.duration !== null && (
                      <React.Fragment>
                        {item.duration.duration} Months
                        <br />
                        Start :{" "}
                        <Moment format="MMM Do YYYY">
                          {item.duration.startDate}
                        </Moment>
                        <br />
                        End :{" "}
                        <Moment format="MMM Do YYYY">
                          {item.duration.endDate}
                        </Moment>
                      </React.Fragment>
                    )}
                  </td>
                  <td>
                    {item.appSubmit && (
                      <span>
                        Complete
                      </span>
                    )}
                    {!item.appSubmit && (
                      <span>
                        Pending
                      </span>
                    )}
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-md-12">
        <div className="card shadow-none border">
          <div className="card-header p-3">
            <i className="fa fa-square wf-phase5-box mr-2" aria-hidden="true"></i>
            <span className="h3">
              Please upload the required documents for this candidate as listed below.
            </span>
          </div>
          <div className="card-body p-3">
            <div className="table-responsive">
              <button
                className="btn btn-sm btn-link pl-0 mr-0"
                onClick={handleDocumentLoad}
              >
                Refresh
              </button>
              <table className="table align-items-center table-flush table-hover table-striped border">
                <thead className="thead-light">
                  <tr>
                    <th>S.No.</th>
                    <th>Date & Time</th>
                    <th>Requirement</th>
                    <th>Notes</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {reqDocuments.map((doc, key) => (
                    <tr>
                      <td>{doc.id}</td>
                      <td>{doc.documnetName}</td>
                      <td>
                        {getUploadStatus(doc)}
                      </td>
                      {getUploadedDoc(doc)}
                    </tr>
                  ))} */}
                  {reqDocuments.map((item, key) =>
                    <tr>
                      <td>{key + 1}</td>
                      <td>
                        <Moment format="MMM Do YYYY, h:mm a">
                          {item.addedDateTime}
                        </Moment>
                      </td>
                      {getReqRefDocs(item)}
                      <td>{getPopover1(item.notes)}</td>
                      {getReqUploadedDocs(item, "req")}
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {/* {docShowHide &&
        <UploadDocPopup
          uploadDocShowHide={docShowHide}
          handleUploadDocModalShowHide={handleUploadDocShowHide}
          runningApplication={[wfTask]}
          selectedDocType={selectedDoc ? `${selectedDoc.id}_c2c_${usrType === "recruiter" ? candidateObj.activeloans : candidateObj.loanamountlimit}` : ""}
          messageAlert="Added Successfully"
        ></UploadDocPopup>} */}

      {docShowHide &&
        <UploadDocPopup
          uploadDocShowHide={docShowHide}
          handleUploadDocModalShowHide={handleUploadDocShowHide}
          runningApplication={wfTask}
          selectedDocType={docType}
          contactDoc={docType === "" ? "Your document has been successfully attached to workbench portal" : "Your required document has been successfully attached to workbench portal"}
        ></UploadDocPopup>}
    </React.Fragment>
  );
}
